import { render, staticRenderFns } from "./edit-broadcast.vue?vue&type=template&id=fda483a4"
import script from "./edit-broadcast.vue?vue&type=script&lang=js"
export * from "./edit-broadcast.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports